<template>
  <Field
    class="LaptopDescription"
    :label="$t('description')"
    :placeholder="$t('description')"
    type="textarea"
    :value="articleLaptop.description"
    @update:value="$up('description', $event)" />
</template>

<script>

export default {
  props: {
    articleLaptop: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.LaptopDescription {
  margin-top: 0.5rem;
}
</style>

<i18n>
{
  "en": {
    "description": "Description"
  }
}
</i18n>
